export { CVUploadModal } from './CVUploadModal.js';
import { CVUploadModal } from './CVUploadModal.js';
export default CVUploadModal;
//# sourceMappingURL=index.js.map